module.exports = __webpack_public_path__ + "img/fincor_black1.3d400010.png";